import React, {useEffect, useState} from "react";
import {
    convertFromHTML,
    EditorState,
    RichUtils
} from "draft-js";
import Editor from "@draft-js-plugins/editor";
import "./RaikoTextEditorStylesheet.scss"
import addLinkPlugin from "./plugins/addLinkPlugin";
import BlockStyleToolbar from "./blockStyles/BlockStyleToolbar";
import {stateToHTML} from "draft-js-export-html";
import ContentState from "draft-js/lib/ContentState";


const RaikoTextEditor = ({text, setText}) => {

    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [plugins, setPlugins] = useState([addLinkPlugin]);


    const onChange = editorState => {
        setEditorState(editorState)
        const contentState = editorState.getCurrentContent();
        setText(stateToHTML(contentState))
    };

    const handleKeyCommand = command => {
        const newState = RichUtils.handleKeyCommand(
            editorState,
            command
        );
        if (newState) {
            onChange(newState);
            return "handled";
        }
        return "not-handled";
    };

    const onUnderlineClick = () => {
        onChange(
            RichUtils.toggleInlineStyle(editorState, "UNDERLINE")
        );
    };

    const onBoldClick = () => {
        onChange(RichUtils.toggleInlineStyle(editorState, "BOLD"));
    };

    const onItalicClick = () => {
        onChange(
            RichUtils.toggleInlineStyle(editorState, "ITALIC")
        );
    };

    const onStrikeThroughClick = () => {
        onChange(
            RichUtils.toggleInlineStyle(editorState, "STRIKETHROUGH")
        );
    };

    const onHighlight = () => {
        onChange(
            RichUtils.toggleInlineStyle(editorState, "HIGHLIGHT")
        );
    };

    const onAddLink = () => {
        const selection = editorState.getSelection();
        const link = window.prompt("لینک مورد نظر را وارد نمایید.");
        if (!link) {
            this.onChange(RichUtils.toggleLink(editorState, selection, null));
            return "handled";
        }
        const content = editorState.getCurrentContent();
        const contentWithEntity = content.createEntity("LINK", "MUTABLE", {
            url: link
        });
        const newEditorState = EditorState.push(
            editorState,
            contentWithEntity,
            "create-entity"
        );
        const entityKey = contentWithEntity.getLastCreatedEntityKey();
        onChange(RichUtils.toggleLink(newEditorState, selection, entityKey));
        return "handled";
    };

    const toggleBlockType = blockType => {
        onChange(RichUtils.toggleBlockType(editorState, blockType));
    };

    useEffect(() => {
        const contentState = editorState.getCurrentContent();
        const editorText = stateToHTML(contentState)
        if (typeof text !== 'undefined' && editorText === "<p><br></p>") {
            if (text.length > 0) {
                const contentState = convertFromHTML(text)
                const content = ContentState.createFromBlockArray(
                    contentState.contentBlocks,
                    contentState.entityMap
                );
                setEditorState(EditorState.createWithContent(content))
            } else {
                setEditorState(EditorState.createEmpty())
            }
        }
    }, [text])

    return (
        <div className="textEditorContainer">
            <div className={"textEditorToolbarContainer"}>
                <BlockStyleToolbar
                    editorState={editorState}
                    onToggle={toggleBlockType}
                />
                <div className="text-link-icon" onClick={onAddLink} id="link_url"/>
                <div className="text-strikethrough-icon" onClick={onStrikeThroughClick}/>
                <div className="text-underline-icon" onClick={onUnderlineClick}/>
                <div className="text-italic-icon" onClick={onItalicClick}/>
                <div className="text-bold-icon" onClick={onBoldClick}/>
            </div>

            <div className="textEditorTextContainer">
                <Editor
                    editorState={editorState}
                    handleKeyCommand={handleKeyCommand}
                    plugins={plugins}
                    onChange={onChange}
                />
            </div>
        </div>
    )
}


export default RaikoTextEditor;